import { render, staticRenderFns } from "./comp_Footer.vue?vue&type=template&id=06c2581a&scoped=true&"
import script from "./comp_Footer.vue?vue&type=script&lang=js&"
export * from "./comp_Footer.vue?vue&type=script&lang=js&"
import style0 from "./comp_Footer.vue?vue&type=style&index=0&id=06c2581a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c2581a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFooter,VIcon,VRow})
